<template>
  <div class="overflow-hidden relative rounded-lg">
    <div class="flex" :style="containerStyle" ref="container">
      <slot />
    </div>

    <slot name="buttons" :previous="previous" :next="next">
      <div class="space-x-2 absolute right-3 bottom-3 flex">
        <button
          @click="previous(true)"
          :disabled="!hasPreviousSlide"
          class="h-10 w-10 flex items-center justify-center rounded-full bg-white p-2 border-solid border-2 focus:outline-none transition duration-200 cursor-pointer select-none"
          :class="{
            'border-blue-300 text-blue-300': hasPreviousSlide,
            'border-gray-400 text-gray-400': !hasPreviousSlide,
          }"
        >
          <i class="sr-2 sr-v2-chevron transform rotate-90"></i>
        </button>

        <button
          @click="next(true)"
          :disabled="!hasNextSlide && !loop"
          class="h-10 w-10 flex items-center justify-center rounded-full bg-white p-2 border-solid border-2 focus:outline-none transition duration-200 cursor-pointer select-none"
          :class="{
            'border-blue-300 text-blue-300':
              hasNextSlide || (!hasNextSlide && loop),
            'border-gray-400 text-gray-400': !hasNextSlide,
          }"
        >
          <i class="sr-2 sr-v2-chevron transform -rotate-90"></i>
        </button>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
    },
    timer: Number,
    transition: {
      type: String,
      default: "transform 0.5s ease-in-out",
    },
    loop: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    totalSlides: 0,
    activeSlide: 0,
    interval: null,
  }),
  computed: {
    interface: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    containerWidth() {
      return this.totalSlides * 100 + "%";
    },
    activeSlidePosition() {
      return "-" + (100 / this.totalSlides) * this.activeSlide + "%";
    },
    containerStyle() {
      return {
        width: this.containerWidth,
        transform: `translateX(${this.activeSlidePosition})`,
        transition: this.transition,
      };
    },
    hasNextSlide() {
      return this.activeSlide !== this.totalSlides - 1;
    },
    hasPreviousSlide() {
      return this.activeSlide !== 0;
    },
  },
  watch: {
    activeSlide(value) {
      this.interface = value;
    },
    interface(value) {
      if (this.activeSlide !== value) {
        this.activeSlide = value;
      }
    },
  },
  methods: {
    goToSlide(slideIndex) {
      this.activeSlide = slideIndex;
    },
    next(cancelTimer) {
      if (cancelTimer) {
        clearInterval(this.interval);
      }

      if (this.hasNextSlide) {
        this.activeSlide++;
      } else if (this.loop) {
        this.activeSlide = 0;
      }
    },
    previous(cancelTimer) {
      if (cancelTimer) {
        clearInterval(this.interval);
      }

      if (this.hasPreviousSlide) {
        this.activeSlide--;
      }
    },
  },
  mounted() {
    this.totalSlides = this.$refs.container.children.length;

    if (this.timer) {
      this.interval = setInterval(this.next, this.timer * 1000);
    }
  },
};
</script>
